import React from 'react';
import Table from 'react-bootstrap/Table';


function tab() {
    return (
        
          <div>
            <Table striped bordered hover size="sm" className="tab">
  <thead>
    <tr>
      <th className="bito">#</th >
      <th  className="bito">Plant</th>
      <th  className="bito">Diseases</th>
      <th  className="bito">Prevention</th>
      
    </tr>
  </thead>
  <tbody>
    <tr  className="bito">
      <td>1</td>
      <td>Cassava</td>
      <td>Cassava Mosaic </td>
      <td>To prevent Cassava Mosaic Disease (CMD) is the practice of phytosanitation, disease resistant varieties, cultural practices, vector control and mild-strain protection.
Phytosanitation is a general term used as a means of improving the health status of cassava planting material and for removing sources of inoculum from which further spread of CMD can occur through the activity of the whitefly vector.
There are three features of phytosanitation:
This include 
I.	Crop hygiene involving removal of all diseased cassava or immediately around sites to be used for new planting.
II.	The use of CMD-free stem cuttings as vegetative planting material.
III.	Removal (roguing) of diseased plants from within crops stand.
</td>
      
     
    </tr>
    <tr  className="bito">
      <td>2</td>
      <td>Cocoa</td>
      <td>Black Pod </td>
      <td>There are numerous ways to curb black pod. These are the few ways mentioned below:
Cultural Control: A spacing of 3.1 x 3.1m and pruning of trees are recommended for cocoa planting inorder to allow more light and air flow around the trees. When this practice is done it will help to reduce the level of humity that will cause blackpod disease.
Chemical Control: The application of copper fungicide,Metalaxyl (Ridomil) and cuprous oxide (Perenox) will help eliminate 
 Black pod incidences in cocoa farms and increase the harvest of cocoa pod. 
Biological control: Heavy application of chemical fungicide would eventually leads to resistant of pathogen and causing soil and water pollutions. Hence, more sustainable and environmental friendly method will  be established and implemented, such as biological control.Several  species of fungi from the genera of Trichodema is identified  to be important endophyte, to control black pod caused by Phytophthora spp.
</td>
     
     
    </tr>
    <tr  className="bito">
      <td>3</td>
      <td>Plantain</td>
      <td>Yellow sigatoka </td>
      <td>•	Reduce humidity in the plot through a proper management of irrigation and drainage (drip or under foliage spray are less favourable to the development of the fungus than overhead sprinklers). Weeding, up to date de-suckering, a planting density of 1650-1850 plants and maintenance of edges, will allow good aeration of plot.
•	Cut all the leaves on the mother plant during harvest
•	Quickly destroy all fallow plots to avoid creating infestation reserves.
•	Avoid overpopulating your plantain.
</td>

</tr>
<tr  className="bito">
      <td>4</td>
      <td>Cabbage</td>
      <td>Ring spot</td>
      <td>•	Remove infected leaves and spraying fungicide.
•	Only plant healthy seedlings on your field.
•	Wait until the residue are completely rotted before replanting on the field
•	Consider crop rotation for 2-3 years with a non-host crop.
•	Treat a small quantity of each seed lot, and test germination before treating all seed.

</td>
      
     
    </tr>

    <tr  className="bito">
      <td>5</td>
      <td>Cashew</td>
      <td>Red rust </td>
      <td>	•	Remove all infected parts and destroy them and replant the area with resistant varieties
•	Clean away all debris in between plants to prevent rust from spreading
•	Dust the plant plants with sulfur early in the season to prevent infection or to keep mild infection from spreading
Avoid splashing water onto the leaves, as this can help spread rust.


</td>
</tr>

<tr  className="bito">
      <td>6</td>
      <td>Coconut</td>
      <td>Stem bleeding  </td>
      <td>	•	Aviod wounding palm trunks at all stages of growth, maintenance, and during their harvest and transport for installation in a landscape.
•	Do not drive stakes into palm trunks to secure them to trucks.
•	Avoid contact of wounded palm stems with soil.
•	Do not install sprinkler irrigation emitters that spray water on the coconut trunks.
•	Place irrigation emitters at least 12 inches from a coconut palm and direct them away from the trunk.
•	Inspect  plants for symptoms regularly

</td>
       </tr>

       <tr  className="bito">
      <td>7</td>
      <td>Cotton</td>
      <td>Wilt</td>
      <td>•Choose resistant cultivars
•	Destroy crop residues
•	Use clean propagation materials (seed can be treated effectively with hot water).
•	Disinfect tools, machinery and irrigation water in green house crops.
•	Prevent stress from plants.
or symptoms regularly

</td>
       </tr>
       <tr  className="bito">
      <td>8</td>
      <td>Cowpea</td>
      <td>Anthracnose</td>
      <td>•	Plant resistant plant or buy healthy transplants.
•	Plant in well-drained soil. Enrich the soil with compost inorder to help plant resist disease.
•	Water the plant with a drip sprinkler, as opposed to an  overhead sprinkler. Dont touch the plants when they are wet


</td>
       </tr>
       
       <tr  className="bito">
      <td>9</td>
      <td>Groundnut</td>
      <td>Early leaf spot</td>
      <td>•	Plant improved groundnut varieties (samnut 22 and 23) for more vigorous plants.
•	Use correct planting density (50cm x 30cm or 50cm x 40cm)
•	Mix crops of groundnut with maize or sorghum.


</td>
       </tr>
       <tr  className="bito">
      <td>10</td>
      <td>Maize</td>
      <td>Charcoal rot </td>
      <td>•	Early planting and low plant population will decrease the competition for water and nutrient 
•	Good water management such as strong irrigation practice, particularly when approaches the flowering stage reduce drought stress. The fungus does not survive well in moist soils.
•	Fertility: Adequate levels of available P and K will reduce nutrient stress and encourage plant growth.
•	Insect management: Controlling insect damage and wounding to crops will help minimize potential points of infection.
•	Hybrid selection: Use hybrids resistant to Diplodia and Gibberella stalk rot, as these tend to offer genetic resistance to charcoal stalk rot as well.



</td>
       </tr>
       <tr  className="bito">
      <td>11</td>
      <td>Mango</td>
      <td>Leaf blight</td>
      <td>•	Internal growth should be removed, leaving only the peripheral foliage. Prune defoliate branch terminals and mummified inflorescences during the growth season and clip spent fruit stalks during harvest.
•	Apply fertilizer sparingly and with caution. Too much fertilizer encourages a rapid leaf flush and if this occurs during periods of frequent wet weather, tress can become diseased. The best time to apply fertilizers is immediately following harvest so that tress produce an autumn flush.

</td>
       </tr>
       
       <tr  className="bito">
      <td>13</td>
      <td>Oil Palm</td>
      <td>Leaf blight</td>
      <td>•	Monitor palms and palm stumps for the conks.
•	Remove the conk and place in a trash receptacle that will be incinerated or delivered to a landfill. Do not place in trash that will be recycled in the landscape.


</td>
       </tr>
    
    
  </tbody>
</Table>  
        </div>
    )
}

export default tab;
